import { render, staticRenderFns } from "./Byan.vue?vue&type=template&id=c97e16ba&scoped=true"
import script from "./Byan.vue?vue&type=script&lang=js"
export * from "./Byan.vue?vue&type=script&lang=js"
import style0 from "./Byan.vue?vue&type=style&index=0&id=c97e16ba&prod&lang=css"
import style1 from "./Byan.vue?vue&type=style&index=1&id=c97e16ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97e16ba",
  null
  
)

export default component.exports